<!--
  ~ Copyright © 2025 Gavin Sawyer. All rights reserved.
  -->

<span class="harness"><span class="between"><ng-container *ngTemplateOutlet="contentTemplate" /></span></span>

<ng-template #badgeSymbolTemplate>
  @if (containerDirective.badgeSymbolTemplateRef$(); as badgeSymbolTemplateRef) {<div id="badgeSymbol">
    <ng-container *ngTemplateOutlet="badgeSymbolTemplateRef" />
  </div>}
</ng-template>
<ng-template #contentTemplate>
  @if (exchangeService.rate$()) {@if (currencySignSymbol$(); as symbol) {<div class="symbol"><span class="harness"><span class="between"><svg
    [attr.viewBox]="'0 0 ' + symbol.viewBoxWidth + ' ' + symbol.viewBoxHeight + ''"
    xmlns="http://www.w3.org/2000/svg">
    <g>
      <rect
        [attr.height]="symbol.viewBoxHeight"
        [attr.width]="symbol.viewBoxWidth"
        opacity="0"
        x="0"
        y="0" />
      @for (path of symbol.paths; track $index) {<path
        [attr.d]="path.definition"
        [attr.fill-opacity]="path.opacity"
        fill="currentColor" />}
    </g>
  </svg></span></span></div>}}
  @if (exchangeService.rate$(); as exchangeRate) {<div class="label"><span class="harness"><span class="between">{{ input$() / 100 * exchangeRate | currency:exchangeService.userCurrency$():'':exchangeService.userCurrency$() === 'BTC' ? '1.0-8' : undefined }}</span></span></div>} @else {<span><span i18n>working</span>{{ ellipsesService.ellipses$() }}</span>}
  <ng-container *ngTemplateOutlet="badgeSymbolTemplate" />
</ng-template>
